import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'pm-asterisk',
    imports: [],
    templateUrl: './pm-asterisk.component.html',
    styleUrl: './pm-asterisk.component.scss'
})
export class PmAsteriskComponent {

}
